// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const raging_bolt: PokeData = {
  "id": 1021,
  "name": "raging-bolt",
  "height": 52,
  "weight": 4800,
  "base_experience": 295,
  "types": [
    PokeType.ELECTRIC,
    PokeType.DRAGON
  ],
  "api_moves": [
    "stomp",
    "thunder",
    "zap-cannon",
    "dragon-breath",
    "twister",
    "sunny-day",
    "charge",
    "calm-mind",
    "shock-wave",
    "dragon-pulse",
    "discharge",
    "dragon-tail",
    "electric-terrain",
    "dragon-hammer",
    "body-press",
    "rising-voltage",
    "thunderclap"
  ],
  "moves": [
    "thunder",
    "zap-cannon",
    "dragon-breath",
    "sunny-day",
    "calm-mind",
    "dragon-pulse",
    "electric-terrain",
    "thunder-shock",
    "quick-tempo",
    "thunderbolt",
    "dragon-claw",
    "inner-spirit",
    "great-roar"
  ],
  "evolution_chain": {
    "id": 545,
    "item": null,
    "species": [
      {
        "name": "raging-bolt",
        "order": 1023,
        "types": [
          PokeType.ELECTRIC,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 135,
    "speed": 94,
    "ability_power": 172
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
